import { render, staticRenderFns } from "./BillingProtocolsMenuBtns.vue?vue&type=template&id=1459f982&scoped=true&"
import script from "./BillingProtocolsMenuBtns.vue?vue&type=script&lang=js&"
export * from "./BillingProtocolsMenuBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1459f982",
  null
  
)

export default component.exports